import { __read, __assign } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { useRef, useState, useEffect } from 'react';
import { createContext } from '../utils/createContext.js';

var _a = __read(createContext({
    name: "DetectInputMethod",
}), 2), useDetectInputMethod = _a[0], DetectInputMethodContext = _a[1];
var DetectInputMethodProvider = function (_a) {
    var children = _a.children;
    var usedKeyboardRef = useRef(false);
    var _b = __read(useState(false), 2), hasTouched = _b[0], setHasTouched = _b[1];
    var usedKeyboardTrue = function () { return (usedKeyboardRef.current = true); };
    var usedKeyboardFalse = function () { return (usedKeyboardRef.current = false); };
    var onFirstTouch = function () {
        setHasTouched(true);
        window.removeEventListener("touchstart", onFirstTouch);
    };
    useEffect(function () {
        window.addEventListener("keydown", usedKeyboardTrue);
        window.addEventListener("mousemove", usedKeyboardFalse);
        window.addEventListener("touchstart", onFirstTouch);
        return function () {
            window.removeEventListener("keydown", usedKeyboardTrue);
            window.removeEventListener("mousemove", usedKeyboardFalse);
            window.removeEventListener("touchstart", onFirstTouch);
        };
    }, []);
    var isUsingKeyboard = function () { return usedKeyboardRef.current; };
    return (jsx(DetectInputMethodContext.Provider, __assign({ value: { isUsingKeyboard: isUsingKeyboard, hasTouched: hasTouched } }, { children: children })));
};

export { DetectInputMethodProvider, useDetectInputMethod };
//# sourceMappingURL=useDetectInputMethod.js.map
